import { RootState } from '../../stores/store';

export const mainSelector = (state: RootState) => state.main;
